import  { apiConfig } from "../helpers";
import { authHeader } from '../helpers';
import axios from 'axios';
export const voucheryService = {
    create,
    getAll,
    getVoucherList,
    sprzedaj,
    getClientVouchers,
    getVoucheryKlientaLista,
    deleteKlientVoucher,
    deleteVoucher,
    getVoucher,
    updateVoucher,
    addNadplata,
    updateVoucherKlient
};

function create(data)
{
    return axios.post('/api/services/app/Vouchery/Create',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function getAll(data)
{
    return axios.get('/api/services/app/Vouchery/GetAll', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: data
    })
}
function getVoucherList()
{
    return axios.get('/api/services/app/Vouchery/GetVoucherList', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader()
    })
}

function sprzedaj(data)
{
    return axios.post('/api/services/app/Vouchery/SprzedajVoucher',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}

function getClientVouchers(id)
{
    return axios.get('/api/services/app/Vouchery/GetClientVouchers', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            clientid: id
        }
    })
}
function getVoucheryKlientaLista(data)
{
    return axios.get('/api/services/app/Vouchery/GetVoucheryKlientaLista', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: data
    })
}
function deleteKlientVoucher(id)
{
    return axios.delete('/api/services/app/Vouchery/DeleteKlientVoucher', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            id: id
        }
    })
}
function deleteVoucher(id)
{
    return axios.delete('/api/services/app/Vouchery/Delete', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }
    })
}
function getVoucher(id)
{
    return axios.get('/api/services/app/Vouchery/Get', {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
        params: {
            Id: id
        }
    })
}
function updateVoucher(data)
{
    return axios.put('/api/services/app/Vouchery/Update',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function addNadplata(data)
{
    return axios.post('/api/services/app/Vouchery/AddNadplata',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}
function updateVoucherKlient(data)
{
    return axios.put('/api/services/app/Vouchery/UpdateVoucherKlient',data, {
        baseURL: apiConfig.apiUrl,
        headers: authHeader(),
    })
}